document.addEventListener("DOMContentLoaded", () => {
  const scaleWrap = document.querySelector("[data-scale-selector]");
  if (!scaleWrap) return;

  const pills = scaleWrap.querySelectorAll(".mif-scale-pill");
  if (!pills.length) return;

  // Horizon uses <variant-picker> — may or may not exist
  const variantPicker = document.querySelector("variant-picker");

  // Hide Shopify's native variant picker ONLY for the "Scale" option
  // Other variant options (e.g. size, colour) must remain visible
  function hideNativeScale() {
    if (variantPicker) {
      // 1) Fieldsets (radio-button style) — hide only those whose legend says "Scale"
      variantPicker.querySelectorAll("fieldset").forEach(function(fs) {
        var legend = fs.querySelector("legend, .label, label");
        if (legend && legend.textContent.toLowerCase().includes("scale")) {
          fs.style.display = "none";
        }
      });

      // 2) Dropdown style — hide only the wrapper whose label says "Scale"
      variantPicker.querySelectorAll(".variant-option--dropdowns").forEach(function(wrapper) {
        var lbl = wrapper.querySelector("label");
        if (lbl && lbl.textContent.toLowerCase().includes("scale")) {
          wrapper.style.display = "none";
        }
      });
    }

    // 3) Fallback: block-level wrappers — only target fieldsets / dropdown wrappers, never the whole variant-picker
    document.querySelectorAll(".product-details fieldset, .product-details .variant-option--dropdowns").forEach(function(el) {
      var lbl = el.querySelector("legend, label");
      if (lbl && lbl.textContent.toLowerCase().includes("scale") && !el.querySelector("[data-scale-selector]")) {
        el.style.setProperty("display", "none", "important");
      }
    });
    console.log("MIF: hid native scale picker");
  }

  hideNativeScale();
  // Horizon may lazy-render — retry once after short delay
  setTimeout(hideNativeScale, 500);

  // Detect which variant Shopify has selected on load (URL param or picker state)
  function getActiveScaleOnLoad() {
    // 1) Check URL ?variant= param and match to picker value
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get("variant");

    if (variantId && variantPicker) {
      // Check radios for checked one
      var checkedRadio = variantPicker.querySelector("input[type='radio']:checked");
      if (checkedRadio) return checkedRadio.value.toLowerCase().trim();

      // Check selects for selected option
      var sel = variantPicker.querySelector("select");
      if (sel && sel.value) return sel.value.toLowerCase().trim();

      // Check data-variant-id attributes
      var match = variantPicker.querySelector("[data-variant-id='" + variantId + "']");
      if (match) {
        var val = match.value || match.dataset.optionValue || match.textContent;
        if (val) return val.toLowerCase().trim();
      }
    }

    return null;
  }

  // Match active pill to Shopify's selected variant, or default to first pill
  var activeScale = getActiveScaleOnLoad();
  var activePill = null;

  if (activeScale) {
    pills.forEach(function(p) {
      if (p.dataset.scale && p.dataset.scale.toLowerCase().trim() === activeScale) {
        activePill = p;
      }
    });
  }

  // Fallback: if no URL match or no matching pill, click first pill to force sync
  if (!activePill) {
    activePill = pills[0];
    // Defer a synthetic click so turbo cache has time to load, syncing price to first pill
    setTimeout(function() { pills[0].click(); }, 150);
  }

  activePill.classList.add("active");
  var initLabel = document.querySelector("[data-mif-scale-selected] span");
  if (initLabel) initLabel.textContent = activePill.dataset.scale || activePill.textContent.trim();

  /* === TURBO VARIANT CACHE === */
  var variantMap = {}; // scale (lowercase) → full variant object

  // 1) Sync cache — instant if Shopify.product is available (no network)
  function buildCacheFromGlobal() {
    try {
      var variants = (window.Shopify && Shopify.product && Shopify.product.variants) || [];
      variants.forEach(function(v) {
        if (v.option1) variantMap[v.option1.toLowerCase().trim()] = v;
        if (v.option2) variantMap[v.option2.toLowerCase().trim()] = v;
        if (v.option3) variantMap[v.option3.toLowerCase().trim()] = v;
      });
      if (variants.length) console.log("MIF: turbo cache built from Shopify.product —", Object.keys(variantMap).length, "entries");
    } catch(e) {}
  }
  buildCacheFromGlobal();

  // 2) Async fallback — fetch product JSON if sync cache is empty
  var productUrl = variantPicker ? variantPicker.dataset.productUrl : null;
  if (!Object.keys(variantMap).length && productUrl) {
    fetch(productUrl + ".js")
      .then(function(r) { return r.json(); })
      .then(function(product) {
        if (!product || !product.variants) return;
        product.variants.forEach(function(v) {
          if (v.option1) variantMap[v.option1.toLowerCase().trim()] = v;
          if (v.option2) variantMap[v.option2.toLowerCase().trim()] = v;
          if (v.option3) variantMap[v.option3.toLowerCase().trim()] = v;
        });
        console.log("MIF: turbo cache built from fetch —", Object.keys(variantMap).length, "entries");
      })
      .catch(function(e) {
        console.log("MIF: could not fetch variant data", e);
      });
  }

  // Turbo instant price update — same-frame paint with requestAnimationFrame
  function instantPriceUpdate(scale) {
    var variant = variantMap[scale];
    if (!variant || !variant.price) return;

    var priceEl = document.querySelector("product-price .price") ||
                  document.querySelector(".price") ||
                  document.querySelector("[data-product-price]");
    if (!priceEl) return;

    var newPrice = (variant.price / 100).toLocaleString("en-AU", {
      style: "currency",
      currency: "AUD"
    });

    // Write price instantly
    priceEl.textContent = newPrice;

    // Force same-frame glow — no transition on first paint
    priceEl.style.transition = "none";
    priceEl.style.transform = "scale(1.12)";
    priceEl.style.filter = "brightness(1.35)";
    priceEl.style.textShadow = "0 0 14px rgba(255,170,60,.65)";

    // Settle back on next frame — ensures animation actually plays
    requestAnimationFrame(function() {
      priceEl.style.transition = "all .18s ease";
      priceEl.style.transform = "scale(1)";
      priceEl.style.filter = "";
      priceEl.style.textShadow = "";
    });

    // Clean up inline styles after settle
    setTimeout(function() {
      priceEl.style.removeProperty("transition");
      priceEl.style.removeProperty("transform");
      priceEl.style.removeProperty("filter");
      priceEl.style.removeProperty("text-shadow");
    }, 400);

    // Sync the price pulse tracker so it doesn't double-fire
    if (window._mifLastPrice !== undefined) {
      window._mifLastPrice = newPrice;
    }

    console.log("MIF: turbo price →", newPrice);
  }

  pills.forEach(pill => {
    pill.addEventListener("click", () => {
      // Block clicks on unavailable pills
      if (pill.classList.contains("unavailable")) return;

      const scale = pill.dataset.scale?.toLowerCase().trim();
      if (!scale) return;

      let matched = false;

      // Sync with variant picker if it exists
      if (variantPicker) {
        // Horizon radio buttons
        const radios = variantPicker.querySelectorAll("input[type='radio']");
        radios.forEach(radio => {
          if (radio.value.toLowerCase().trim().includes(scale)) {
            radio.checked = true;
            radio.dispatchEvent(new Event("change", { bubbles: true }));
            matched = true;
          }
        });

        // Fallback: Horizon dropdown selects
        if (!matched) {
          const selects = variantPicker.querySelectorAll("select");
          selects.forEach(select => {
            [...select.options].forEach(opt => {
              if (opt.value.toLowerCase().trim().includes(scale)) {
                select.value = opt.value;
                select.dispatchEvent(new Event("change", { bubbles: true }));
                matched = true;
              }
            });
          });
        }
      }

      // Instant price update — don't wait for Shopify round-trip
      instantPriceUpdate(scale);

      // active styling
      pills.forEach(p => p.classList.remove("active"));
      pill.classList.add("active");

      // tactile snap: tap → shrink → spring back
      pill.style.transform = "scale(.92)";
      setTimeout(() => { pill.style.transform = "scale(1)"; }, 90);

      // fast pulse feedback
      pill.classList.remove("pulse");
      void pill.offsetWidth;
      pill.classList.add("pulse");

      // update "Selected:" label
      const label = document.querySelector("[data-mif-scale-selected] span");
      if (label) label.textContent = pill.dataset.scale || scale;

      if (!matched) {
        console.log("MIF: no variant match for:", scale);
      }
    });
  });

  // Dim unavailable variants — only if we can confirm they're disabled
  if (variantPicker) {
    var anyMatched = false;

    pills.forEach(pill => {
      const scale = pill.dataset.scale?.toLowerCase().trim();
      if (!scale) return;

      // Check if this scale maps to a disabled variant
      let foundDisabled = false;
      let foundEnabled = false;

      const radios = variantPicker.querySelectorAll("input[type='radio']");
      radios.forEach(radio => {
        if (radio.value.toLowerCase().trim().includes(scale)) {
          anyMatched = true;
          if (radio.disabled) foundDisabled = true;
          else foundEnabled = true;
        }
      });

      const selects = variantPicker.querySelectorAll("select");
      selects.forEach(select => {
        [...select.options].forEach(opt => {
          if (opt.value.toLowerCase().trim().includes(scale)) {
            anyMatched = true;
            if (opt.disabled) foundDisabled = true;
            else foundEnabled = true;
          }
        });
      });

      // Only mark unavailable if we found a match AND it's disabled
      if (foundDisabled && !foundEnabled) {
        pill.classList.add("unavailable");
      }
    });

    if (anyMatched) {
      console.log("MIF: variant availability check complete");
    } else {
      console.log("MIF: no variant matches found — all pills remain enabled");
    }
  }

  console.log("MIF: scale pills active —", pills.length, "pills");
});

/* ===================================
   MIF PRICE PULSE — HORIZON SAFE
   Dual approach: variant-change listener
   + polling fallback to catch any update
=================================== */

function initPricePulse() {

  function readPrice() {
    var el = document.querySelector("product-price .price") ||
             document.querySelector(".price") ||
             document.querySelector("[data-product-price]");
    return el ? el.textContent.trim() : "";
  }

  function pulsePrice() {
    var el = document.querySelector("product-price .price") ||
             document.querySelector(".price") ||
             document.querySelector("[data-product-price]");
    if (!el) return;

    // Apply glow directly via inline styles (bypasses Horizon specificity)
    el.style.transition = "transform 150ms ease, text-shadow 200ms ease, filter 150ms ease";
    el.style.transform = "scale(1.08)";
    el.style.filter = "brightness(1.25)";
    el.style.textShadow = "0 0 8px rgba(255,170,60,.7), 0 0 20px rgba(255,170,60,.35)";

    setTimeout(function() {
      el.style.transform = "scale(1)";
      el.style.filter = "brightness(1)";
      el.style.textShadow = "none";
    }, 200);

    // Clean up inline styles after settle finishes
    setTimeout(function() {
      el.style.removeProperty("transform");
      el.style.removeProperty("filter");
      el.style.removeProperty("text-shadow");
      el.style.removeProperty("transition");
    }, 450);

    console.log("MIF: price pulse fired on", el.textContent.trim());
  }

  // Share lastPrice on window so instant price update can sync
  window._mifLastPrice = readPrice();

  // Check for price change after variant interaction
  function checkAndPulse() {
    // Small delay lets Horizon finish its DOM update
    setTimeout(function() {
      var now = readPrice();
      if (now && now !== window._mifLastPrice) {
        window._mifLastPrice = now;
        pulsePrice();
      }
    }, 120);
  }

  // 1) Listen on variant selectors (radios, buttons, dropdowns)
  document.querySelectorAll(
    'variant-selects, variant-radios, [name="id"], .product-variant-option, fieldset input[type="radio"]'
  ).forEach(function(el) {
    el.addEventListener("change", checkAndPulse);
  });

  // 2) Catch clicks on swatch-style buttons
  document.addEventListener("click", function(e) {
    if (e.target.closest &&
        e.target.closest(".product-variant-option, variant-selects, variant-radios, .swatch, [data-option-value]")) {
      checkAndPulse();
    }
  });

  // 3) Polling fallback — catches any method Horizon uses
  setInterval(function() {
    var now = readPrice();
    if (now && now !== window._mifLastPrice) {
      window._mifLastPrice = now;
      pulsePrice();
    }
  }, 300);

  console.log("MIF: price pulse listener active — price:", window._mifLastPrice);
}

document.addEventListener("DOMContentLoaded", initPricePulse);

/* MIF TRUST STRIP — JS INJECTION removed; trust strip now in manifest row only */

/* ===============================
   MIF ADD TO CART — QUEUE SYSTEM
   REMOVED: This was duplicating the theme's built-in product-form.js
   add-to-cart handler, causing items to be added multiple times.
   The theme's product-form-component handles all cart additions.
================================= */

/* ==========================================
   MIF SMART CART OPEN — HORIZON SAFE
   Listens for form submit to /cart/add
   and opens the cart drawer after a debounce
========================================== */

(function() {

  var openTimer = null;

  function openCart() {
    var drawer =
      document.querySelector("cart-drawer-component") ||
      document.querySelector("cart-drawer") ||
      document.querySelector(".cart-drawer");

    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      console.log("MIF: smart cart open");
      return;
    }

    var toggle =
      document.querySelector("[data-cart-toggle]") ||
      document.querySelector(".header__icon--cart");

    if (toggle) {
      toggle.click();
      console.log("MIF: smart cart open via click");
    }
  }

  function scheduleOpen() {
    if (openTimer) clearTimeout(openTimer);
    openTimer = setTimeout(function() {
      openCart();
    }, 180);
  }

  document.addEventListener("submit", function(e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    scheduleOpen();
  });

})();
